module.exports = __webpack_public_path__ + "static/media/logo.89aac694.png";